import { api } from '@/shared/lib/api'

import type { MatchmakingSuggestions } from './types'

/**
 * Sugestões da participação autenticada.
 *
 * Recurso singular, como o perfil de networking: não há `id` no path, então não
 * existe superfície para ler as sugestões de outra pessoa.
 */
export const fetchMatchmakingSuggestions = async (
  digitalProductId: string | number,
  perGroup?: number
): Promise<MatchmakingSuggestions> => {
  const response = await api.get(
    `/user/digital_products/${digitalProductId}/matchmaking_suggestions`,
    { params: perGroup ? { per_group: perGroup } : undefined }
  )

  return response.data
}
